module.exports = "<div class=\"page\">\n  <div class=\"warn\">借款以实际审批为准，请按需合理借款</div>\n  <div class=\"registerbox\">\n    <div class = \"topText\"></div>\n  </div>\n  <div class=\"copyright\" id=\"copyright\">\n    <div class=\"text text_center text_middle\" >\n      <div class=\"company\"></div>\n      <div class=\"address\"></div>\n      <div class=\"phone\"></div>\n      <div class=\"num\"></div>\n      <div class=\"tip\"></div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/module/lowRate/index/index.tpl.html
// module id = OkdR
// module chunks = 5